import { ReactComponent as Ldz02Logo } from 'assets/icons/ldz02Logo-full.svg'
import { selectIsLoggedIn, selectUser } from 'containers/Login/loginSlice'
import { selectChatUnreadNotifications } from 'containers/Chats/chatSlice'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import Message from 'components/icons/Message'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { POPUPS } from 'containers/Home'
import useLogout from 'hooks/useLogout'

const type = process.env.REACT_APP_TYPE

const MenuItem = ({ icon, text, action, isMuted = false }) => {
  return <div
    className='nav__item'
    style={isMuted ? { opacity: 0.5 } : undefined}
    onClick={action}>
    <div className='item__svg'>
      {typeof icon === 'string'
        ? <i className={`icon icon--${icon} s24`} />
        : icon}
    </div>
    <span>{text}</span>
  </div>
}

const Menu = ({ isDesktop = false }) => {
  const unreadMessages = useSelector(selectChatUnreadNotifications)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const { name } = useSelector(selectUser)

  const logout = useLogout()
  const { push } = useHistory()
  const { t } = useTranslation('menu')

  return (
    <aside className={`app__menu ${isDesktop ? '--desktop' : ''}`}>
      {!isDesktop && <>
        <div className='menu__logo center'>
          {type === 'mm'
            ? <>
              <i className='icon icon--logo' />
              <span className='--secFont'>Magazynomaty</span>
            </>
            : type === 'ldz02'
              ? <Ldz02Logo />
              : <i className={`icon icon--${type}-full-logo-v`} />}
        </div>

        <p className='menu__greeting'>
          <span>{t('welcomeToTheBackstage')}{isLoggedIn && name ? `, ${name}` : ''}!</span>
        </p>
      </>}

      {isDesktop
        ? <div className='menu__nav'>
          <MenuItem
            icon='plus'
            text={t('rent')}
            action={() => {
              push('/home')
            }} />

          <hr />

          <MenuItem
            icon='dashboard'
            text={t('dashboard')}
            isMuted={!isLoggedIn}
            action={() => {
              push('/dashboard')
            }} />

          <MenuItem
            icon='mag-details'
            text={t(type === 'mm' ? 'myRentals' : 'warehouses')}
            isMuted={!isLoggedIn}
            action={() => {
              push('/warehouses')
            }} />

          <MenuItem
            icon='user'
            text={t('account')}
            isMuted={!isLoggedIn}
            action={() => {
              push('/account')
            }} />

          <hr />

          <MenuItem
            icon={<Message isNewMessage={!!unreadMessages} />}
            text={t('messages')}
            action={() => {
              push('/chat')
            }} />

          <MenuItem
            icon='settings'
            text={t('settings')}
            action={() => {
              push('/account/settings')
            }} />

          <MenuItem
            icon='help'
            text={t('help')}
            action={() => {
              push('/help')
            }} />

          <div className='space' />

          {isLoggedIn
            ? <MenuItem
              icon='logout'
              text={t('logOut')}
              action={logout} />
            : <MenuItem
              icon='login'
              text={t('logIn')}
              action={() => {
                push('/login')
              }} />}
        </div>
        : <div className='menu__nav'>
          <MenuItem
            icon='mag-details'
            text={t(type === 'mm' ? 'myRentals' : 'warehouses')}
            isMuted={!isLoggedIn}
            action={() => {
              push('/warehouses')
            }} />
          {type === 'mm' && <MenuItem
            icon='magStorage'
            text='MagStore'
            action={() => {
              push(window.location.pathname, LOCATION_STATES.popup(POPUPS.magStore))
            }} />}

          <hr />

          <MenuItem
            icon='settings'
            text={t('settings')}
            action={() => {
              push('/account/settings')
            }} />

          <MenuItem
            icon='help'
            text={t('help')}
            action={() => {
              push('/help')
            }} />

          {isLoggedIn
            ? <MenuItem
              icon='logout'
              text={t('logOut')}
              action={logout} />
            : <MenuItem
              icon='login'
              text={t('logIn')}
              action={() => {
                push('/login')
              }} />}
        </div>}
    </aside>
  )
}

export default Menu